export default __webpack_public_path__ + "static/media/404-page-not-found.9ffb635c.png";